import { toast } from "react-toastify";
import { testimonyRepository } from "../../../providers/repositories/testimonyRepository";
import { t } from "i18next";
import Logger from "../../../utils/Logger";

export const deleteTestimonyUseCase = {
    async exec(id: string | number): Promise<boolean> {
        try {
            await testimonyRepository.delete(id);
            toast.success(t("action.deleteSuccess"));
            return true;
        } catch (error) {
            toast.error(t("action.deleteError"));
            Logger.error("deleteTestimonyUseCase", error);
        }
        return false;
    },
};
